<script setup lang="ts">
  import { getFlagByCountryCode } from "@utils/constants/regions";
  import type { HistoCreative } from "@/components/Admin/Histo/HistoDataTable/types";

  defineProps<{
    creatives: Record<string, HistoCreative[]>;
    isMultiCountry: boolean;
  }>();

  function getCostShare(item: { cost_share?: number }): number {
    if (!item?.cost_share) return 0;
    return Math.round(item.cost_share * 100);
  }
</script>

<template>
  <section>
    <h3 class="heading-section mb-3">Top creatives</h3>
    <template v-if="Object.keys(creatives).length">
      <template
        v-for="(items, country) in creatives"
        :key="country">
        <div
          v-if="isMultiCountry"
          class="mb-2">
          <span class="font-medium text-sm text-foreground">
            {{ getFlagByCountryCode(country as string) }} {{ country }}
          </span>
        </div>
        <div class="grid grid-cols-3 gap-3 mb-4">
          <div
            v-for="(creative, idx) in items"
            :key="`creative-${idx}`"
            class="relative rounded-lg overflow-hidden border bg-muted/20">
            <div class="absolute top-2 left-2 bg-background/90 px-2 py-1 rounded text-xs font-medium text-foreground">
              #{{ idx + 1 }} - {{ getCostShare(creative) }}%
            </div>
            <img
              v-if="creative.story_url"
              :src="creative.story_url"
              class="w-full h-auto object-cover"
              loading="lazy" />
            <div
              v-else
              class="h-32 flex items-center justify-center text-foreground/50 text-sm">
              No image available
            </div>
          </div>
        </div>
      </template>
    </template>
    <p
      v-else
      class="text-sm text-foreground/50 italic">
      No creatives available
    </p>
  </section>
</template>
